import React, { FC } from 'react';
import { View, Image, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale as initialScale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Man from '@assets/img/man.png';
import { font as initialFont } from '@styles/fonts';
import { isWeb } from '@helpers';
import UserImage from '@components/common/UserImage';
import { connect } from 'react-redux';
import { SimpleOnPress } from '@interfaces/base';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { PanelProps } from '@components/operatorPanel/components/panel';

interface OperatorNameProps extends SimpleOnPress, Pick<PanelProps, 'CC' | 'scale' | 'font'> {
  disabled?: boolean;
  user: {
    userInfo?: {
      userProfile?: {
        firstName?: string;
        lastName?: string;
      };
    };
  };
}

const OperatorName: FC<OperatorNameProps> = ({ CC, onPress, user: { userInfo = {} }, scale = initialScale, font = initialFont, disabled = false, }) => {
  const { userProfile = {} } = userInfo;
  const { firstName = ' ', lastName = ' ' } = userProfile;

  return (
    <TouchableElement disabled={disabled} onPress={onPress} testID={TEST_IDS.operatorPanel.home.operatorBlockButton}>
      {({ boxStyle }) => (
        <View style={[boxStyle, { flexDirection: 'row', height: scale(72), justifyContent: 'center', alignContent: 'center', alignItems: 'center' }]}>
          <View style={{ flexDirection: 'row', gap: scale(18) }}>
            <View style={{ height: scale(42), justifyContent: 'center' }}>
              <Text style={[font['Headline Large'], { color: CC('Label/Dark/Primary'), userSelect: 'none' }]}>
                {firstName} {lastName}
              </Text>
            </View>
            <UserImage {...{ showAdd: false, size: scale(42), onPress: disabled ? () => {} : onPress, scale, font }} />
          </View>
        </View>
      )}
    </TouchableElement>
  );
};

export default connect(({ user }) => ({ user }), {})(OperatorName);
